export const LOCATOR_TRACKING_NAME = 'Find a Miele Partner';
export const LOCATOR_STORAGE_KEY = 'mieleFinderQueryString';
export const NEWSLETTER_TRACKING_NAME = 'Newsletter Subscription';
export const NEWSLETTER_STORAGE_KEY = 'newsletterEmail';
